/**
 * Created by jiachenpan on 16/11/18.
 */

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function isParamJson(value) {
  const paramArrReg = /^\[\{\"key\"\:.*\}\]$/
  return paramArrReg.test(value)
}

// 规格参数JSON匹配
export function standardFormate(value) {
  if(!isNullOrUndefined(value)) {
    let res = ''
    if (isParamJson(value)) {
      const arr = JSON.parse(value)
      if (!isNullOrUndefined(arr)) {
        arr.forEach(e => {
          res += (e.key + '. ' + e.value + '</br>')
        })
      }
    } else {
      res = value
    }
    return res
  }
}

// 金额格式化
export function formatPrice(number) {
  if (!isNullOrUndefined(number)) {
    number = Number(number)
    const options = {
      style: 'currency',
      currency: 'CNY',
    };
    let res = (number).toLocaleString('zh-CN', options)
    if(!isNullOrUndefined(res)) {
      res = res.replace('¥', '')
    }
    return res
  }
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
  let len = 0
  for (let i = 0; i < val.length; i++) {
    if (val[i].match(/[^\x00-\xff]/gi) != null) {
      len += 1
    } else {
      len += 0.5
    }
  }
  return Math.floor(len)
}

export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"') +
      '"}'
  )
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function objectMerge(target, source) {
  /* Merges two  objects,
     giving the last one precedence */

  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

export function scrollTo(element, to, duration) {
  if (duration <= 0) return
  const difference = to - element.scrollTop
  const perTick = (difference / duration) * 10
  setTimeout(() => {
    element.scrollTop = element.scrollTop + perTick
    if (element.scrollTop === to) return
    scrollTo(element, to, duration - 10)
  }, 10)
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

export const pickerOptions = [
  {
    text: '今天',
    onClick(picker) {
      const end = new Date()
      const start = new Date(new Date().toDateString())
      end.setTime(start.getTime())
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近一周',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近一个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近三个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      picker.$emit('pick', [start, end])
    }
  }
]

export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

export function isNullOrUndefined(node) {
  return (
    node === undefined || node == null || node === '' || node.length === 0
  )
}

export function deepCopy(data) {
  return JSON.parse(JSON.stringify(data))
}
export function deepCopyNew(o) {
  if (o instanceof Array) { // 先判断Array
    var n = []
    for (var i = 0; i < o.length; ++i) {
      n[i] = deepCopyNew(o[i])
    }
    return n
  } else if (o instanceof Object) {
    var n = {}
    for (var i in o) {
      n[i] = deepCopyNew(o[i])
    }
    return n
  } else {
    return o
  }
}

export function cleanObj(obj) {
  const type = typeof obj
  switch (type) {
    case 'string':
      obj = ''
      break
    case 'number':
      obj = 0
      break
    case 'boolean':
      obj = false
      break
    case 'object':
      if (obj instanceof Array) {
        obj = []
      } else {
        for (const objectKey in obj) {
          obj[objectKey] = cleanObj(obj[objectKey])
        }
      }
      break
    default:
      break
  }
  return obj
}

export function transformMain(data) {
  let arry = [];
  let i = 0;
  let rowSize = 0;
  arry.push([]);
  data.forEach(ele => {
    rowSize += ele.span
    if (rowSize > 24) {
      if (ele.span < 24) {
        rowSize = 0
        rowSize += ele.span
      }
      arry.push([]);
      i++;
      arry[i].push(ele);
    } else if (rowSize == 24) {
      rowSize = 0
      arry[i].push(ele);
      arry.push([]);
      i++;
    } else {
      arry[i].push(ele);
    }

  })
  return arry;
}

// 设置表格第一行的颜色
export function getRowClass({ row, column, rowIndex, columnIndex }) {
  if (rowIndex === 0) {
    return 'background-color: #f3f3f3;color: #000000;font-weight: 500;'
  }
}

export function timeFormate (value, attr) {
  let res = ''
  if (!isNullOrUndefined(value)) {
    res = value.replace('T', ' ')
  } else {
    res = ''
  }
  return res
}

export function timeType(time) {
  let timestamp2 = new Date(time).getTime();
  let b = (new Date()).valueOf()
  return timestamp2 > b
}

export function getQueryString(name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  let after = window.location.search.substr(1) || window.location.hash.split("?")[1];
  if(after){
    let r = after.match(reg);
    if (r != null) return (r[2]);
  }
  return null;
}

export function  httpsUpdata(path){
  let url =path
  if(path.match('^http://')){
    url = url.replace(/^http:\/\//i,'https://');
  }
  return url
}

export function  redTitleTime(value,index){
  let today = new Date();
  let beforeOneMonth = new Date(today.getFullYear(), (today.getMonth()), today.getDate());
  let time = new Date(timeFormate(value))
  let year =time .getFullYear()
  let month = time .getMonth()
  let day = time .getDate()
  let inputDate = new Date(year, (month+1), day);
  if (inputDate.getTime() < beforeOneMonth.getTime()||Number(index)>1) {
    return false;
  }
  return true;
}

// 确认请求
export function ajaxConfirm(vm, ajax, param, confirmText, confirmBtnText = '确定') {
  return new Promise((resolve, reject) => {
    vm.$confirm(confirmText, '提示', {
      confirmButtonText: confirmBtnText,
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      vm.loading = true
      ajax(param).then(res => {
        resolve(res.data)
        vm.loading = false
      }).catch(e => {
        reject(e)
        vm.loading = false
      })
    }).catch(e => {
      reject(e)
      vm.loading = false
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/index.js